import { DeliveryServer } from '@/models/delivery-server/delivery-server';
import { MailWizzInstanceService } from './mail-wizz-instance.serive';

export class DeliveryServerService extends MailWizzInstanceService {
    protected getResourceUrl() { return 'api/deliveryServers' };
    protected getResponseMapper() { return DeliveryServer.parseJson }
}

export const deliveryServerService = new DeliveryServerService();
